<template>
    <div class="search-page">
        <div v-if="searchResults" class="page">
            <div class="cover"></div>
            <div class="container">
                <div class="content">
                    <h1>Căutare: <strong>{{ searchQuery }}</strong></h1>
                    <p>
                        Am găsit {{products.length}} produse
                    </p>

                    <div class="white-page" v-if="searchResults.products.length === 0">
                        <h1>Niciun rezultat</h1>
                        <p>
                            Căutarea nu a întors niciun rezultat. Puteți încerca să folosiți termeni de căutare mai cuprinzători.
                        </p>
                    </div>

                    <div v-else>
                        <div class="white-page">
                            <h1>Restrânge căutarea</h1>

                            <b-form-group label="Vezi produse de la furnizorii:">
                                <b-form-checkbox-group
                                    v-model="selectedSuppliers"
                                    :options="suppliers"
                                ></b-form-checkbox-group>
                            </b-form-group>

                            <b-row class="mb-3">
                                <b-col md="3">
                                    <span>Ordonează după:</span>
                                    <b-form-select v-model="orderBy" size="sm">
                                        <b-form-select-option value="PRICE_ASC">Preț crescător</b-form-select-option>
                                        <b-form-select-option value="PRICE_DESC">Preț descrescător</b-form-select-option>
                                    </b-form-select>
                                </b-col>
                            </b-row>

                            <h1>Rezultate</h1>

                            <b-alert variant="danger" :show="products.length === 0">
                                Nu am putut găsi niciun produs potrivit filtrelor selectate.
                            </b-alert>

                            <div v-if="inStockProducts.length > 0">
                                <h2>În stoc</h2>
                                <SearchPageTable :products="inStockProducts" @onAdd="onAddItem" @onDelete="onDeleteItem"/>
                            </div>
                            <div v-if="supplierStockProducts.length > 0">
                                <h2>În stoc furnizor</h2>
                                <SearchPageTable :products="supplierStockProducts" @onAdd="onAddItem" @onDelete="onDeleteItem"/>
                            </div>
                            <div v-if="outOfStockProducts.length > 0">
                                <h2>Indisponibil</h2>
                                <SearchPageTable :products="outOfStockProducts" @onAdd="onAddItem" @onDelete="onDeleteItem"/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-else class="placeholder">
            <h1>Caută un produs folosind bara de mai sus.</h1>
            <p>Poți introduce fragmente din denumirea produsului sau codul de produs, cu sau fără cratime.</p>
        </div>
    </div>
</template>

<script>
    import {mapState} from "vuex";
    import axios from "@/utils/axios-instance";
    import store from "@/store";
    import SearchPageTable from "@/components/SearchPageTable";

    export default {
        name: 'SearchPage',
        components: {SearchPageTable},
        data() {
            return {
                isLoaded: false,
                selectedSuppliers: [],
                orderBy: "PRICE_ASC",
            }
        },
        computed: {
            suppliers() {
                if(!this.searchResults) {
                    return [];
                }

                let rawSuppliers = {};

                this.searchResults.products.forEach(product => {
                    if(!rawSuppliers[product.supplier_id]) {
                        rawSuppliers[product.supplier_id] = {
                            text: product.supplier.name,
                            value: product.supplier_id,
                            disabled: false
                        };
                    }
                });

                let suppliers = [];
                for(var index in rawSuppliers) {
                    suppliers.push(rawSuppliers[index]);
                }

                return suppliers;
            },
            products() {
                if(!this.searchResults) {
                    return [];
                }

                let products = this.searchResults.products;

                // Filter out products from non-selected manufacturers
                products = products.filter(product => {
                    return this.selectedSuppliers.includes(product.supplier_id);
                });

                // Order the products based on the selected criteria
                if(this.orderBy === 'PRICE_ASC') {
                    products.sort(function (a, b) {
                        return parseFloat(a.price.ron_price) - parseFloat(b.price.ron_price);
                    });
                } else if(this.orderBy === 'PRICE_DESC') {
                    products.sort(function (a, b) {
                        return parseFloat(b.price.ron_price) - parseFloat(a.price.ron_price);
                    });
                }

                return products;
            },
            inStockProducts() {
                return this.products.filter(product => product.stocks[0].stock_status === "IN_STOCK");
            },
            supplierStockProducts() {
                return this.products.filter(product => product.stocks[0].stock_status === "SUPPLIER_STOCK");
            },
            outOfStockProducts() {
                return this.products.filter(product => product.stocks[0].stock_status === "OUT_OF_STOCK");
            },
            ...mapState(['searchResults', 'searchQuery', 'workingOffer']),
        },
        created() {
            this.refreshSelectedSuppliers();
        },
        watch: {
            // Update the selected suppliers list when the search query (and therefore the supplier list) changes
            suppliers() {
                this.refreshSelectedSuppliers();
            }
        },
        methods: {
            refreshSelectedSuppliers() {
                this.selectedSuppliers = [];
                this.suppliers.forEach(supplier => {
                    this.selectedSuppliers.push(supplier.value);
                });
            },
            async onAddItem({stockId}) {
                let loader = this.$loading.show({
                    container: this.$refs.currentOffer,
                });

                await axios.post(`offer/${this.workingOffer.offer.offer_id}/add-item`, {
                    product_stock_id: stockId,
                })
                await store.dispatch('reloadWorkingOffer');

                loader.hide();
            },
            async onDeleteItem({itemId}) {
                let loader = this.$loading.show({
                    container: this.$refs.currentOffer,
                });

                await axios.delete(`offer/${this.workingOffer.offer.offer_id}/item/${itemId}`);
                await store.dispatch('reloadWorkingOffer');

                loader.hide();
            },
        }
    }
</script>

<style scoped>
    .search-page {
        flex-grow: 1;
        display: flex;
    }

    .page {
        flex-grow: 1;
        position: relative;
    }

    .cover {
        width: 100%;
        height: 264px;
        position: relative;
        background: #024A8C;
    }

    .container {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    .content {
        margin-top: 60px;
        color: white;
        width: 100%;
    }

    .white-page {
        background: white;
        border-radius: 5px;
        color: black;
        padding: 25px 20px;

        margin-top: 50px;
        margin-bottom: 20px;

        -webkit-box-shadow: 0px 0px 14px 2px rgba(0, 0, 0, 0.31);
        -moz-box-shadow: 0px 0px 14px 2px rgba(0, 0, 0, 0.31);
        box-shadow: 0px 0px 14px 2px rgba(0, 0, 0, 0.31);
    }

    .white-page h1 {
        color: #024A8C;
        font-weight: 600;
    }

    .white-page h2, h3, h4, h5, h6 {
        color: #6F6F6F;
        margin-top: 10px;
    }

    h1 {
        font-size: 2rem;
    }

    h2 {
        font-size: 1.1rem;
    }

    h3 {
        font-size: 1rem;
    }

    .placeholder {
        flex-grow: 1;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        color: grey;
        padding: 20px;
        text-align: center;
    }

    .placeholder h1 {
        font-size: 2rem;
    }

    .placeholder p {
        font-size: 1.2rem;
    }

</style>
